module.exports = __webpack_public_path__ + "img/success_type_modif.1a3745fb.svg";